import {
  GET_FEE_MANAGEMENT_OPERATIONSLIST_SUCCESS,
  GET_FEE_MANAGEMENT_OPERATIONSLIST_FAILED,
  RESET_GET_FEE_MANAGEMENT_OPERATIONSLIST,
  LOADING_GET_FEE_MANAGEMENT_OPERATIONSLIST,
  NETWORK_ERROR_GET_FEE_MANAGEMENT_OPERATIONSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetFeeManagementOperationsList = () => {
  return { type: RESET_GET_FEE_MANAGEMENT_OPERATIONSLIST };
};

const getFeeManagementOperationsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GET_FEE_MANAGEMENT_OPERATIONSLIST });
    await partnerServices
      .post("getFeeMasterOperationList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(getFeeManagementOperationsListSuccess(res.data));
            break;
          default:
            dispatch(getFeeManagementOperationsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GET_FEE_MANAGEMENT_OPERATIONSLIST,
          payload: err,
        });
      });
  };
function getFeeManagementOperationsListSuccess(data) {
  return {
    type: GET_FEE_MANAGEMENT_OPERATIONSLIST_SUCCESS,
    payload: data,
  };
}
function getFeeManagementOperationsListFailed(data) {
  return {
    type: GET_FEE_MANAGEMENT_OPERATIONSLIST_FAILED,
    payload: data,
  };
}

export {
  resetGetFeeManagementOperationsList,
  getFeeManagementOperationsList,
};
